import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useStateContext } from '../../context/ContextProvider';
import { renderText } from '../hooks/TextVeiw';
import { useTranslation } from 'react-i18next';
import { productsData } from '../../constants/index'; // ✅ استدعاء البيانات الثابتة
import P_related_products from './P_related_products';

const ProductDetails = () => {
    const { currentLang } = useStateContext();
    const { t } = useTranslation();
    const location = useLocation();
    const { id } = useParams(); // ✅ قراءة رقم المنتج من الرابط

    // إذا جاء من التنقل الداخلي → عندك بيانات في state
    let cardData = location.state?.cardData;

    // إذا فتح الرابط مباشرة → ابحث عن المنتج في البيانات الثابتة
    if (!cardData && id) {
        cardData = productsData.find(p => p.id === parseInt(id));
    }

    if (!cardData) {
        return (
            <div className="p-4 text-center">
                <p>{t("Product not found")}</p>
            </div>
        );
    }

    const isAr = currentLang === "ar";
    const title = isAr ? cardData.title_Ar : cardData.title_En;
    const description = isAr ? cardData.description_Ar : cardData.description_En;

    return (
        <div className="">



            <div className="container  pt-24 pd:mt-32 lg:pt-36 flex lg:flex-row flex-col  z-10  gap-5">
                <div className="max-w-4xl mx-auto bg-light-glass1 dark:bg-dark-glass1 border border-light-glassStrock2 dark:border-dark-glassStrock1 shadow-md backdrop-blur-xl rounded-xl p-6">

                    <div className="w-full h-64 md:h-96 bg-light-secondary   overflow-hidden rounded-xl mb-6">
                        <img
                            src={cardData.image}

                            className="w-full h-full object-cover"
                        />
                    </div>




                    <h1 className="h3 md:h2 text-light-title dark:text-dark-title mb-6">
                        {title}
                    </h1>
                    <div className="border-t border-light-strock w-full mb-4" />
                    <div className="prose max-w-none">
                        <p className="body-1 text-light-subtitle dark:text-dark-subtitle whitespace-pre-line">
                            {renderText(description)}
                        </p>
                    </div>

                </div>
                <P_related_products id={cardData.id} />
            </div>


        </div>
    )
};

export default ProductDetails;


//import React from 'react'
//import { useLocation } from 'react-router-dom'
//import { useStateContext } from '../../context/ContextProvider'
//import { renderText } from '../hooks/TextVeiw'
//import { useTranslation } from 'react-i18next'


//import P_related_products from './P_related_products'

//const ProductDetails = () => {
//    const { currentLang } = useStateContext()
//    const { t } = useTranslation()
//    const location = useLocation()

//    const { cardData } = location.state


//    if (!cardData) {
//        return (
//            <div className="p-4 text-center">
//                <p>{t("Product not found")}</p>
//            </div>
//        )
//    }

//    const isAr = currentLang === "ar"
//    const title = isAr ? cardData.title_Ar : cardData.title_En
//    const description = isAr ? cardData.description_Ar : cardData.description_En

    //return (
    //    <div className="">



    //        <div className="container  pt-24 pd:mt-32 lg:pt-36 flex lg:flex-row flex-col  z-10  gap-5">
    //            <div className="max-w-4xl mx-auto bg-light-glass1 dark:bg-dark-glass1 border border-light-glassStrock2 dark:border-dark-glassStrock1 shadow-md backdrop-blur-xl rounded-xl p-6">

    //                <div className="w-full h-64 md:h-96 bg-light-secondary   overflow-hidden rounded-xl mb-6">
    //                    <img
    //                        src={cardData.image}

    //                        className="w-full h-full object-cover"
    //                    />
    //                </div>




    //                <h1 className="h3 md:h2 text-light-title dark:text-dark-title mb-6">
    //                    {title}
    //                </h1>
    //                <div className="border-t border-light-strock w-full mb-4" />
    //                <div className="prose max-w-none">
    //                    <p className="body-1 text-light-subtitle dark:text-dark-subtitle whitespace-pre-line">
    //                        {renderText(description)}
    //                    </p>
    //                </div>

    //            </div>
    //            <P_related_products id={cardData.id} />
    //        </div>


    //    </div>
    //)
//}

//export default ProductDetails